import { extractSize, extractSizeWidthHeight } from "../helpers/extractSize";
import { loadGLB } from "../helpers/loadGLB";
import { setActiveCalcValue } from "./calculator";
import { setTableDefaultColor } from "./changeMaterialColor";
import { changePolkaStellazhi } from "./changeObjectParams/changes/stellazhi/changePolkaStellazhi";
import { changeStoykiDerzhatelRulona } from "./changeObjectParams/changes/stoyki/changeStoykiDerzhatelRulona";
import { changeGazlift, changeNozhkiStula, changeOpora } from "./changeObjectParams/changes/stulya";
import {
    changePerfopanelKSM,
    changePolkaPribornayaKSM,
    changePolkaPribornayaSMK,
} from "./changeObjectParams/changes/tables/up/up";
import { changeVerstakOpora } from "./changeObjectParams/changes/verstaki/changeVerstakOpora";
import { changeVerstakPolka } from "./changeObjectParams/changes/verstaki/changeVerstakPolka";
import { changeVarstakCategoryTumba } from "./changeObjectParams/changes/verstaki/changeVarstakCategoryTumba";
import { toggleSingleSceneObject } from "./changeObjectParams/togglers";
import { cloneMaterial } from "./cloneObject";
import { getActiveHitbox } from "./getActiveHitbox";
import { loadElementiForTables } from "./loadElementiForTables/loadElementiForTables";
import { applyConfiguratorLighting } from "./scene";
import { setCameraOnEditMode } from "./setUpCamera";
import { cardItems } from "./vars/cardItems";
import { makeCSS2Dannotaition } from "./annotations";
import { changeDoors } from "./changeObjectParams/changes/wardrobes/changeDoors";
import { DEFAULT_COUNTS, DEFAULT_COUNTS_YASHCHIKS } from "./changeObjectParams/changes/wardrobes/pos_map";
import { setVisibleSpriteTextInObj } from "../helpers/setVisibleSpriteTextInObj";
import { hideAndRemoveInArr } from "./changeObjectParams/helpers";
import { LOAD_DATA } from "./changeObjectParams/changes/wardrobes/changeKomplektatsia";
import { changeYashchik } from "./changeObjectParams/changes/wardrobes/changeYashchik";
import { changePolkaWardrobes } from "./changeObjectParams/changes/wardrobes/changePolkaWardrobes";
import { updateTextDoorState } from "./doorAnimationStore";

export async function addObjectToScene(loadData, calc_table_name, isLoadFromJSON = false) {
    const { objectName, glbName, allArrTable, name, folderName } = loadData;

    const targetName = objectName ?? name;

    if (!targetName) {
        console.error("Имя объекта не задано.");
        return;
    }

    const isWardrobe = folderName === "wardrobes";

    document.querySelector(".add_in_room_btn_wrap").classList.remove("hide");
    document.querySelector(".assist_btns").classList.add("hide");
    if (isWardrobe) document.querySelector(".animate-doors_btn_wrap").classList.remove("hide");

    const existingObject = servObj.scene.getObjectByName(targetName);

    let target = null;

    if (existingObject) {
        target = handleLoadedObject({ objectName: targetName, calc_table_name, isLoadFromJSON, existingObject });
    } else {
        const glb = await loadGLB(loadData);
        setTableDefaultColor(servObj[allArrTable]);
        await loadElementiForTables(glbName, glb);
        target = handleLoadedObject({ objectName: targetName, calc_table_name, isLoadFromJSON });
    }

    return target;
}

const animateDoorsBtn = document.getElementById("animate-doors");

export function handleLoadedObject({ objectName, calc_table_name, isLoadFromJSON, existingObject = null, loadData }) {
    const obj = initObjectInScene(objectName, false, isLoadFromJSON, loadData); // бывший _addObjectToScene
    const target = existingObject || obj;

    setActiveCalcValue(calc_table_name, true);

    setTimeout(() => {
        getActiveHitbox();
        servObj.building.checkCollision();
    }, 50);

    makeCSS2Dannotaition(target);

    servObj.annotations.forEach((ann) => ann.element.classList.remove("ann_target_table"));

    const targetAnnotation = target.children.find((child) => child.isCSS2DObject);
    if (targetAnnotation) targetAnnotation.element?.classList.add("ann_target_table");

    setVisibleSpriteTextInObj({ targetObject: target, visible: false });

    if (loadData) target.userData.loadData = loadData;

    if (objectName.includes("shkaf")) {
        updateTextDoorState(animateDoorsBtn);
    }

    return target;
}

function initObjectInScene(objectName, isFirstLoad, isLoadFromJSON = false, loadData) {
    const scene = servObj.scene;
    if (!scene || !objectName) return;

    const globalObject = scene.getObjectByName(objectName);
    if (!globalObject) {
        throw new Error(`Не удалось найти объект с name: `, objectName, typeof objectName);
    }

    const object = prepareObject(globalObject.clone(), objectName, isFirstLoad, loadData);
    if (!object) return;

    object.children.forEach((child) => {
        const newMaterial = cloneMaterial(child.material, object);
        child.material = newMaterial;
    });

    scene.add(object);
    setupSceneState(object, isLoadFromJSON);
    initDefaultElements(object, isLoadFromJSON);
    updateUI();

    return object;
}

// --- helpers ---

function prepareObject(object, objectName, isFirstLoad, loadData) {
    applyConfiguratorLighting();

    let { width, depth, height } = getObjectDimensions(object, objectName);

    const sourceLoadData = loadData || object.userData.loadData || {};
    const { folderName, typeName, wardrobeType } = sourceLoadData;

    const isInstrumentalWardrobe = object.name.includes("shkaf__shir__") || object.name.includes("shkaf__shi__");
    const hasLoadData = typeof loadData !== "undefined";

    const cardItem = getCardItem(objectName, folderName, typeName, isInstrumentalWardrobe, wardrobeType, hasLoadData);

    object.userData.defaultSize = object.userData.defaultSize || {
        width: Number(cardItem.defaultWidth) || width,
        depth: Number(cardItem.defaultDepth) || depth,
        height: Number(cardItem.defaultHeight) || height,
    };

    if (servObj.redactorModeObject?.userData.preventForm) {
        object.userData.preventForm = servObj.redactorModeObject.userData.preventForm;
    }

    Object.assign(object.userData.loadData, {
        objectName,
        objectWidth: width,
        objectDepth: depth,
        ...cardItem,
    });

    updateTableSize(object.userData.defaultSize, { width, depth, height }, isFirstLoad);

    if (servObj.redactorModeObject && servObj.isRedactorMode) {
        servObj.redactorModeObject.removeFromParent();
    }

    cloneMaterials(object);
    showHiddenChildren(object);

    object.position.set(0, 10, 0);
    object.userData.editModePos = object.position.clone();

    return object;
}

const objectsWithHeight = ["stellazhi", "wardrobes"];

function getObjectDimensions(object, objectName) {
    let size = extractSize(objectName);
    let width = (size && Number(size.split("x")[0])) || 0;
    let depth = (size && Number(size.split("x")[1])) || 0;
    let height = null;

    if (objectsWithHeight.includes(object.userData.loadData.folderName)) {
        size = extractSizeWidthHeight(objectName);
        width = size.width;
        depth = size.depth;
        height = size.height;
    }
    return { width, depth, height };
}

function getCardItem(objectName, folderName, typeName, isInstrumentalWardrobe, wardrobeType, hasLoadData) {
    const splitName = objectName.split("__");

    const defaultFind =
        cardItems[folderName]?.[typeName]?.find((item) => item.name.includes(`${splitName[0]}__${splitName[1]}`)) || {};
    const instrFind = LOAD_DATA[wardrobeType];

    return isInstrumentalWardrobe && hasLoadData ? instrFind : defaultFind;
}

function updateTableSize(defaultSize, currentSize, isFirstLoad) {
    const { width, depth, height } = defaultSize;
    const { width: cw, depth: cd, height: ch } = currentSize;

    Object.assign(window.servObj.tableSize, {
        tableWidth: { default: width, current: cw },
        tableDepth: { default: depth, current: cd },
        tableHeight: { default: height, current: ch },
    });

    if (isFirstLoad) {
        servObj.tableColor.changeable_painted_metal_material.current =
            servObj.tableColor.changeable_painted_metal_material.default;
        servObj.tableColor.changeable_kromka_material.current = servObj.tableColor.changeable_kromka_material.default;
    }
}

function cloneMaterials(object) {
    object.traverse((child) => {
        if (child.material) {
            child.material = Array.isArray(child.material)
                ? child.material.map((mat) => mat.clone())
                : child.material.clone();
        }
    });
}

function showHiddenChildren(object) {
    const excludedNames = [
        "razdelitel__raskroinii",
        "ogranichitel",
        "dopolnitelnoe_pokritie_polok",
        "elektropanel",
        "dopolnitelnaya_polka",
        "bokovoy_fiksator_rulona",
        "tumba_podvesnaya",
        "otsinkovka",
        "hitbox",
    ];

    object.traverse((child) => {
        if (!child.visible && !child.isSprite && !excludedNames.some((excluded) => child.name.includes(excluded))) {
            child.visible = true;
        } else if (child.isSprite && child.userData.isLabel) {
            child.visible = false;
        }
    });
}

function setupSceneState(object, isLoadFromJSON) {
    if (!servObj.isRedactorMode) setCameraOnEditMode(object);

    servObj.isRedactorMode = true;
    servObj.redactorModeObject = object;
}

const defaultElementRules = [
    {
        patterns: ["verstak__stoleshnitsa"],
        toggles: [
            {
                allObjects: "allVerstakTumbaRight",
                activeArray: "activeVerstakTumbaRight",
                name: "verstak__tumba__1__right",
            },
            {
                allObjects: "allVerstakNozhkiLeft",
                activeArray: "activeVerstakNozhkiLeft",
                name: "verstak__nozhki__1200x700__left",
            },
        ],
    },
    {
        patterns: ["ksm"],
        action: () => {
            changePolkaPribornayaKSM();
            changePerfopanelKSM();
        },
    },
    {
        patterns: ["stoyka", "sur"],
        action: () => changeStoykiDerzhatelRulona(true, 1),
        requireAll: true,
    },
    { patterns: ["stellazh__sab__"], shelfCount: 6 },
    { patterns: ["stellazh__sa__"], shelfCount: 4 },
    { patterns: ["stellazh__sum__"], shelfCount: 4 },
    { patterns: ["smk"], action: () => changePolkaPribornayaSMK() },
    {
        patterns: ["stul__sta"],
        action: () => {
            changeGazlift(true, "standart");
            changeOpora(true, "kolesa");
            changeNozhkiStula(true);
        },
    },
    {
        patterns: ["verstak__vs"],
        action: () => {
            changeVerstakOpora("left", true);
            changeVerstakPolka("left");
            changeVarstakCategoryTumba("verstak__tumba__1__right", "right", true);
        },
    },
    { patterns: ["shkaf__shk__", "shkaf__sha__", "shkaf__shi__", "shkaf__shi__"], action: () => changeDoors(true) },
    { patterns: ["shkaf__sha__"], shelfCount: 4 },
    {
        patterns: ["shkaf__shi__", "shkaf__shir__"],
        action: (object) => {
            const { wardrobeType } = object.userData.loadData;

            const count = DEFAULT_COUNTS["instrumentalniy"][wardrobeType];

            hideAndRemoveInArr(servObj.activePolkaWardrobe);
            hideAndRemoveInArr(servObj.activeYashchikWardrobe);
            hideAndRemoveInArr(servObj.activeYashchikWardrobeBig);

            initShelves(count, true);

            // Добавляем ящики
            const countsYashchiks = DEFAULT_COUNTS_YASHCHIKS[wardrobeType];

            if (typeof countsYashchiks === "undefined") {
                return console.warn("Не найдена карта ящиков для данного объекта: ", object);
            }

            const { big, small } = countsYashchiks;

            if (big > 0) {
                for (let i = 1; i <= big; i++) {
                    changeYashchik({ count: i, size: "big" });
                }
            }

            if (small > 0) {
                for (let i = 1; i <= small; i++) {
                    changeYashchik({ count: i, size: "small" });
                }
            }
        },
    },
];

function initDefaultElements(object, isLoadFromJSON) {
    if (isLoadFromJSON) return;

    defaultElementRules.forEach((rule) => {
        const { patterns, action, shelfCount, toggles, requireAll } = rule;
        const name = object.name;
        const isWardrobes = name.includes("shkaf__shk__") || name.includes("shkaf__sha__");

        const matched = requireAll ? patterns.every((p) => name.includes(p)) : patterns.some((p) => name.includes(p));

        if (!matched) return;

        if (shelfCount) {
            initShelves(shelfCount, isWardrobes);
        } else if (toggles) {
            toggles.forEach((t) => {
                toggleSingleSceneObject({
                    allObjects: servObj[t.allObjects],
                    activeArray: servObj[t.activeArray],
                    name: t.name,
                    isChecked: true,
                    position: { x: 0, y: 10, z: 0 },
                });
            });
        } else if (action) {
            action(object);
        }
    });
}

function initShelves(count, isWardrobes = false) {
    for (let i = 1; i <= count; i++) {
        const isDraggable = i > 1 && i < count;
        isWardrobes ? changePolkaWardrobes(i, true, true) : changePolkaStellazhi(i, isDraggable, true);
    }
}

function updateUI() {
    document.querySelector(".view2d3d").classList.add("hide");
    document.querySelector(".sizes").classList.add("hide");

    const saveChangeBtn = document.getElementById("add_in_room_btn");
    saveChangeBtn.textContent = servObj.isEditMode ? "Сохранить изменения" : "Добавить в помещение";
    saveChangeBtn.parentNode.classList.remove("hide");

    const isWardrobe = servObj.redactorModeObject.userData.loadData.folderName === "wardrobes";

    if (isWardrobe) document.querySelector(".animate-doors_btn_wrap").classList.remove("hide");
}
